import React, { HTMLAttributes, ReactNode } from 'react'
import styled from 'styled-components'
import Header from '@components/Header'
import Footer from '@components/Footer'
import { IHeaderProps } from '@components/Header/Header'

export interface ILayoutProps extends HTMLAttributes<HTMLDivElement>, IHeaderProps {}

const SMain = styled.main`
  overflow: hidden;
`

const Layout: React.FC<ILayoutProps> = ({ children, contacts, contractHref, lkHref, ...rest }) => {
  return (
    <div {...rest}>
      <Header contacts={contacts} contractHref={contractHref} lkHref={lkHref} />
      <SMain>{children}</SMain>
      <Footer />
    </div>
  )
}

export default Layout
